import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,

  // admin only
  ...(IS_ADMIN
    ? {
        LINK_COLOR: '#f58220',
        HEADER_COLOR2: '#303030',
        USER_LOGO_BACKGROUND: '#fff',
        USER_LOGO_COLOR: '#f58220',
        CARD_BG: '#212121',
        MENU_BACKGROUND: '#222',
        SELECTED_MENU_BG: '#000',
        MENU_BORDER_COLOR: '#f58220',
        TABLE_SORT_ICON: '#fff',
        PRIMARY_BUTTON_SIZE: '20',
        HEADER_COLOR: '#292929',
      }
    : {}),

  // non-admin only
  ...(!IS_ADMIN && window.$environment.CURRENT_LAYOUT === 'OldUi'
    ? {
        LINK_COLOR: '#f58220',
        HEADER_COLOR: '#f58220',
        PRIMARY_MAIN: '#fff',
        BACKGROUND: '#efefef',
        HEADER_COUNT_TEXT: '#222',
        PRIMARY_CONTRAST: '#222',
        SECONDARY_MAIN: '#f58220',
        PUBLIC_HEADERCOLOR: '#000',
        LANGUAGE_SWITCH: '#f58220',
        HEADER_TEXT: '#f4f6f9',
        BODY_BACKGROUND: '#fff',
        MODAL_BACKGROUND: '#fff',
        MODAL_BORDER: '#d9d9d9',
        MODAL_LINK: '#f58220',
        ACTIVE_ROW: 'rgba(254, 236, 222, 0.7)',
        PAGINATION_BACKGROUND: '#fff',
        PAGINATION_COLOR: '#000',
        BACKGROUND_MENU: '#fff',
        RANGE_PICKER: {
          CELL_BG: '#dfdfdf',
          CELL_HOVER_BG: '#bbbbbb',
        },
        INPUT_BORDER: '#ccc',
      }
    : {}),
};

export const fonts = IS_ADMIN ? parent.fonts : ['Yanone Kaffeesatz', 'tahoma'].join(',');

// non-admin-only font extras
export const secondaryFont = !IS_ADMIN ? 'Permanent Marker' : undefined;
export const tableFont = !IS_ADMIN ? 'tahoma' : undefined;
export const headerFont = !IS_ADMIN ? '24px' : undefined;
export const subTitle = !IS_ADMIN ? '22px' : undefined;
export const titleLabel = !IS_ADMIN ? '24px' : undefined;
export const formlabelFont = !IS_ADMIN ? '24px' : undefined;
export const buttonFont = !IS_ADMIN ? '23px' : undefined;
export const inputFont = !IS_ADMIN ? '16px' : undefined;
export const checkboxFont = !IS_ADMIN ? '17px' : undefined;
export const addbuttonFont = !IS_ADMIN ? '23px' : undefined;
export const companyDataFont = !IS_ADMIN ? '28px' : undefined;
export const iftaReport = !IS_ADMIN ? '16px' : undefined;
export const inspectionInput = !IS_ADMIN ? '24px' : undefined;
export const inspectionresolution = !IS_ADMIN ? '20px' : undefined;
export const companyDashboard = !IS_ADMIN ? '20px' : undefined;
